import * as screens from '@core/layouts/components/menu/screens';
import permissions from './permissions';

export default [
  {
    id: 'videoDashboard',
    title: 'video.dashboard',
    iconName: 'play-stream',
    permissions: [permissions.videoDashboard],
    navLink: '/video',
    screenId: screens.VIDEO_DASHBOARD
  },
  {
    id: 'videoEventsHistory',
    title: 'video.eventsHistory.title',
    iconName: 'video-events',
    permissions: [permissions.eventsHistory],
    navLink: '/video/events-history',
    screenId: screens.VIDEO_EVENTS_HISTORY
  },
  {
    id: 'videoHistory',
    title: 'video.videoHistory.title',
    iconName: 'history-video',
    permissions: [permissions.videoHistory],
    navLink: '/video/history',
    screenId: screens.VIDEO_HISTORY
  }
];
